import React from 'react';
import { langAPI } from '../api';

const flagMap = {
  en: '🇺🇸', zh: '🇨🇳', es: '🇪🇸', fr: '🇫🇷', de: '🇩🇪',
  ja: '🇯🇵', ko: '🇰🇷', ar: '🇸🇦', ru: '🇷🇺', pt: '🇵🇹',
};

const nameMap = {
  en: 'English', zh: '中文', es: 'Español', fr: 'Français', de: 'Deutsch',
  ja: '日本語', ko: '한국어', ar: 'العربية', ru: 'Русский', pt: 'Português',
};

export default function LanguageFlag({ code, showName = false, size = 24 }) {
  return (
    <span style={{ fontSize: size }}>
      {flagMap[code] || '🌐'}
      {showName && <span style={{ marginLeft: 6, fontSize: 14 }}>{nameMap[code] || code}</span>}
    </span>
  );
}
